// src/pages/JudoCoachPro/data/judoCoachProData.js

import {
  FaBookOpen,
  FaChartLine,
  FaChalkboardTeacher,
  FaClipboardCheck,
  FaComments,
  FaGraduationCap,
  FaMedal,
  FaMobileAlt,
  FaQrcode,
  FaTrophy,
  FaUserGraduate,
  FaUsers,
  FaCheckCircle,
} from "react-icons/fa";

export const JUDO_COACH_PRO = {
  name: "Judo Coach Pro",
  logo: "https://www.judo-coach-pro.com/img/logo_judocoach_pro_512.png",

  externalUrl: "https://www.judo-coach-pro.com/",

  eyebrow: "Application web dédiée au judo",

  title: "Progressez, transmettez",
  highlightedTitle: "et suivez vos judokas.",

  description:
    "Judo Coach Pro réunit le suivi des performances, la préparation technique, les passages de grades et les outils pédagogiques dans une application accessible sur tous les appareils.",

  heroImages: ["/images/appli/JCP/001.png", "/images/appli/JCP/002.png"],

  mainIllustration: "/images/judo-coach/illustration_01.webp",

  donationUrl: "https://buy.stripe.com/fZe8xlaqLgYkdj2fYZ",
};

export const JUDO_COACH_AUDIENCES = [
  {
    icon: FaUserGraduate,
    title: "Pour les judokas",
    text: "Révisions, performances, grades et progression personnelle.",
  },
  {
    icon: FaChalkboardTeacher,
    title: "Pour les enseignants",
    text: "Groupes, suivi individuel et outils pédagogiques.",
  },
  {
    icon: FaUsers,
    title: "Pour les clubs",
    text: "Une vision claire de la progression de leurs adhérents.",
  },
];

export const JUDO_COACH_HERO_POINTS = [
  {
    icon: FaMobileAlt,
    label: "Compatible mobile, tablette et ordinateur",
  },
  {
    icon: FaTrophy,
    label: "Résultats, palmarès et passages de grades",
  },
  {
    icon: FaChartLine,
    label: "Statistiques et suivi de progression",
  },
];

export const JUDO_COACH_FEATURE_JOURNEYS = [
  {
    id: "judoka",
    tabLabel: "Espace judoka",
    eyebrow: "Progresser à son rythme",
    title: "Un espace personnel pour réviser et suivre son parcours.",
    description:
      "Le judoka retrouve ses résultats, ses objectifs, ses passages de grades et les contenus nécessaires pour préparer ses prochaines échéances.",
    image: "/images/appli/JCP/Page_Palmares.png",
    imageAlt: "Statistiques et progression du judoka",
    accentLabel: "Accès gratuit",
    icon: FaUserGraduate,
    features: [
      {
        icon: FaTrophy,
        title: "Résultats et palmarès",
        text: "Enregistrer ses compétitions et conserver l’historique de ses performances.",
      },
      {
        icon: FaChartLine,
        title: "Statistiques de progression",
        text: "Visualiser ses combats, ses victoires et ses axes d’amélioration.",
      },
      {
        icon: FaGraduationCap,
        title: "Grades et unités de valeur",
        text: "Suivre ses passages de grades, UV et objectifs techniques.",
      },
      {
        icon: FaBookOpen,
        title: "Révisions techniques",
        text: "Techniques, kata, UV2, arbitrage, lexique et quiz.",
      },
      {
        icon: FaMedal,
        title: "Prépation Physique",
        text: "Suivre ses séances de préparation physique et ses objectifs de performance.",
      },
    ],
    secondaryImage: "/images/appli/JCP/Page_Techniques.png",
    secondaryLabel: "Révision des techniques",
  },
  {
    id: "coach",
    tabLabel: "Espace coach",
    eyebrow: "Accompagner ses groupes",
    title: "Une vision claire de chaque groupe et de chaque judoka.",
    description:
      "L’enseignant organise ses groupes, suit la progression de ses adhérents et partage les informations importantes depuis une seule interface.",
    image: "/images/appli/JCP/Page_Coach_Groupes.png",
    imageAlt: "Gestion des groupes et des judokas",
    accentLabel: "Outils enseignants",
    icon: FaChalkboardTeacher,
    features: [
      {
        icon: FaUsers,
        title: "Gestion des groupes",
        text: "Organiser les judokas par groupe, niveau ou catégorie.",
      },
      {
        icon: FaClipboardCheck,
        title: "Suivi individuel",
        text: "Consulter les résultats, grades et statistiques de chaque adhérent.",
      },
      {
        icon: FaComments,
        title: "Communication sécurisée",
        text: "Échanger avec les judokas et transmettre les informations utiles.",
      },
      {
        icon: FaQrcode,
        title: "Invitation simplifiée",
        text: "Permettre à un judoka de rejoindre un groupe grâce à un QR code.",
      },
      {
        icon: FaCheckCircle,
        title: "Suivi des présences",
        text: "Enregistrer et suivre les présences des judokas lors des séances.",
      },
    ],
    secondaryImage: "/images/appli/JCP/Page_Coach_Appels.png",
    secondaryLabel: "Appels et présences",
  },
];

export const JUDO_COACH_CORE_MODULES = [
  "Performances",
  "Techniques",
  "Kata",
  "Passages de grades",
  "Arbitrage",
  "Événements",
];

export const JUDO_COACH_PRICING_AUDIENCES = [
  {
    id: "judoka",
    label: "Je suis judoka",
    title: "Judo Expert",
    short: "Un espace personnel complet et gratuit.",
    priceText: "Gratuit",
    priceSuffix: "",
    eyebrow: "Accès individuel",
    description:
      "Le judoka dispose gratuitement des outils nécessaires pour suivre sa progression, préparer ses grades et approfondir ses connaissances.",
    features: [
      "Résultats, palmarès et statistiques",
      "Suivi des passages de grades et des UV",
      "Techniques de judo et de ju-jitsu",
      "Révision des kata",
      "Quiz techniques et lexique japonais",
      "Règlement d’arbitrage et tableau de score",
      "Accès aux événements partagés",
    ],
    callToAction: "Créer mon espace judoka",
  },
  {
    id: "coach",
    label: "Je suis enseignant",
    title: "Formules Coach",
    short: "Des outils pour accompagner ses groupes.",
    eyebrow: "Espace enseignant",
    description:
      "Choisissez la capacité adaptée à votre club et retrouvez les outils de suivi, de communication et d’accompagnement.",
    callToAction: "Découvrir l’espace coach",
  },
];

export const JUDO_COACH_COACH_PLANS = [
  
  {
    id: "coach-pro",
    name: "Coach Pro",
    priceText: "20 €",
    suffix: "/an",
    capacity: "Jusqu’à 100 adhérents",
    groups: "3 groupes",
    description:
      "La formule adaptée aux enseignants qui encadrent plusieurs groupes au sein d’un club.",
    recommended: true,
    features: [
      "Toutes les fonctionnalités Coach",
      "Gestion de 3 groupes",
      "Suivi de 100 adhérents maximum",
      "Résultats et palmarès individuels",
      "Suivi des passages de grades",
      "Suivi de présences et d’absences",
      "Communication avec les groupes",
    ],
  },
  {
    id: "coach-ultim",
    name: "Coach Ultim",
    priceText: "30 €",
    suffix: "/an",
    capacity: "Plus de 100 adhérents",
    groups: "Plus de 3 groupes",
    description:
      "Une formule complète pour les enseignants et clubs qui souhaitent centraliser un effectif important.",
    features: [
      "Toutes les fonctionnalités Coach Pro",
      "Gestion de plus de 3 groupes",
      "Suivi de plus de 100 adhérents",
      "Suivi complet de la progression",
      "Outils adaptés aux clubs importants",
      "Communication avec tous les groupes",
    ],
  },
];
